import { Skeleton } from "@blueskydataplatform/shared-ui/components/ui/skeleton";
import Logo from "@/components/logo";

const MCPRegistrationSkeleton = () => (
  <div className="bg-background flex-1">
    {/* Hero */}
    <section className="hero-gradient pt-24 pb-16 md:pt-32 md:pb-20">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center mb-6">
          <Logo className="mb-4" />
        </div>
        <Skeleton className="mx-auto h-8 w-32 rounded-full mb-6" />
        <Skeleton className="mx-auto h-12 w-64 md:w-96 mb-6" />
        <div className="max-w-2xl mx-auto space-y-2">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-3/4 mx-auto" />
        </div>
      </div>
    </section>

    {/* Main content */}
    <section className="py-16 bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mx-auto space-y-10">
          <div>
            <Skeleton className="h-6 w-40 mb-4" />
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Skeleton className="h-4 w-4 shrink-0 rounded" />
                <Skeleton className="h-4 flex-1 max-w-sm" />
              </li>
              <li className="flex items-center gap-2">
                <Skeleton className="h-4 w-4 shrink-0 rounded" />
                <Skeleton className="h-4 flex-1 max-w-md" />
              </li>
              <li className="flex items-center gap-2">
                <Skeleton className="h-4 w-4 shrink-0 rounded" />
                <Skeleton className="h-4 flex-1 max-w-xs" />
              </li>
            </ul>
            <Skeleton className="h-4 w-72 mt-3" />
            <Skeleton className="h-11 w-52 mt-4 rounded-xl" />
          </div>

          <div className="rounded-2xl border border-amber-200/80 dark:border-amber-800/50 p-6 bg-amber-50/50 dark:bg-amber-950/20">
            <Skeleton className="h-6 w-64 mb-3" />
            <Skeleton className="h-4 w-full mb-2" />
            <Skeleton className="h-4 w-11/12 mb-4" />
            <ol className="list-decimal list-inside space-y-2">
              <li>
                <Skeleton className="h-4 w-full inline-block ml-2" />
              </li>
              <li>
                <Skeleton className="h-4 w-4/5 inline-block ml-2" />
              </li>
              <li>
                <Skeleton className="h-4 w-3/4 inline-block ml-2" />
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    {/* Footer */}
    <section className="py-16 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <div className="space-y-2">
            <Skeleton className="h-4 w-full mx-auto max-w-md" />
            <Skeleton className="h-4 w-80 mx-auto" />
          </div>
          <div className="flex flex-wrap justify-center gap-4">
            <Skeleton className="h-11 w-40 rounded-xl" />
            <Skeleton className="h-11 w-36 rounded-xl" />
          </div>
          <Skeleton className="h-4 w-48 mx-auto" />
        </div>
      </div>
    </section>
  </div>
);

export default MCPRegistrationSkeleton;
